import { SettingOutlined } from '@ant-design/icons';
import { Card, Dropdown } from 'antd';

import { Title } from '@atom/typography/typography';
import { Chart } from '@component/chart/chart';
import { ColorEnum } from '@enum/style/color.enum';
import { ApplicationInterface } from '@interface/application/application.interface';
import { getFormattedNumber } from '@util/data/number';

import { useOverviewCard } from './overview-card.hook';
import {
  AppIcon,
  ChartWrapper,
  HeaderTitle,
  HeaderWrapper,
  SettingsButton,
  SettingsWrapper,
  StatCol,
  StatRow,
} from './overview-card.style';

interface OverviewCardProps {
  application: ApplicationInterface;
  onDelete?: () => void;
}

export const OverviewCard = ({ application, onDelete }: OverviewCardProps) => {
  const { onChange, consumers, requests, connections } = useOverviewCard(application);

  const items = [
    {
      key: '1',
      label: 'Delete application',
      danger: true,
    },
  ];

  return (
    <Card hoverable onClick={onChange}>
      <HeaderWrapper>
        <AppIcon />
        <HeaderTitle>{application.name}</HeaderTitle>
        <SettingsWrapper>
          <Dropdown menu={{ items, onClick: onDelete }} trigger={['click']}>
            <SettingsButton type='button' onClick={(e) => e.preventDefault()}>
              <SettingOutlined />
            </SettingsButton>
          </Dropdown>
        </SettingsWrapper>
      </HeaderWrapper>
      <StatRow gutter={[16, 24]}>
        <StatCol span={8}>
          <Title color={ColorEnum.Black70} level={6} weight={400}>
            Total
            <br />
            requests
          </Title>
          <Title level={4} weight={400}>
            {getFormattedNumber(requests)}
          </Title>
        </StatCol>
        <StatCol span={8}>
          <Title color={ColorEnum.Black70} level={6} weight={400}>
            Total
            <br />
            consumers
          </Title>
          <Title level={4} weight={400}>
            {getFormattedNumber(consumers)}
          </Title>
        </StatCol>
        <StatCol span={8}>
          <Title color={ColorEnum.Black70} level={6} weight={400}>
            Total
            <br />
            connections
          </Title>
          <Title level={4} weight={400}>
            {getFormattedNumber(connections)}
          </Title>
        </StatCol>
      </StatRow>
      <Title level={4} weight={400}>
        Api requests
      </Title>
      <ChartWrapper>
        <Chart applicationId={application.id} height={200} />
      </ChartWrapper>
    </Card>
  );
};
